import { Bell, Briefcase, Eye, Home, Newspaper, User } from 'lucide-react';
import type { ReactElement } from 'react';

import type { MessageId } from '~/i18n/messages.ts';
import { KEYBOARD_SHORTCUTS } from '~/modules/keyboard/settings';

export const navigationOptions: {
	command: string[];
	href: string;
	Icon: ReactElement;
	nameId: MessageId;
}[] = [
	{
		command: KEYBOARD_SHORTCUTS.home,
		href: '/dashboard',
		Icon: <Home className="mr-2 size-4" />,
		nameId: 'nav.dashboard',
	},
	{
		command: KEYBOARD_SHORTCUTS.portfolios,
		href: '/portfolios',
		Icon: <Briefcase className="mr-2 size-4" />,
		nameId: 'nav.portfolios',
	},
	{
		command: KEYBOARD_SHORTCUTS.watchlists,
		href: '/watchlists',
		Icon: <Eye className="mr-2 size-4" />,
		nameId: 'nav.watchlists',
	},
	{
		command: KEYBOARD_SHORTCUTS.news,
		href: '/news',
		Icon: <Newspaper className="mr-2 size-4" />,
		nameId: 'nav.news',
	},
	{
		command: KEYBOARD_SHORTCUTS.notifications,
		href: '/notifications',
		Icon: <Bell className="mr-2 size-4" />,
		nameId: 'nav.notifications',
	},
	{
		command: KEYBOARD_SHORTCUTS.user,
		href: '/user',
		Icon: <User className="mr-2 size-4" />,
		nameId: 'nav.user',
	},
];
